import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './../current-user.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
export const TRAINER_STATUS = {
	REGISTRATION_COMPLETED: 'registrationCompleted',
	INCOMPLETE: 'incomplete'
};

@Injectable({ providedIn: 'root' })
export class TrainerService {
	constructor(
		private apiService: ApiService,
		private currentUserService: CurrentUserService
	) { }
	updateTrainerDetails(trainerData, status = 'incomplete') {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer?status=${status}`;
		return this.apiService.put(URL, trainerData);
	}

	getTrainerInfo(userName, certified?, status = '', qpCode = "", version = "") {
		const payload = Helpers.serialize({
			status,
			qpCode,
			version
		});
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/username/${userName}?certified=${certified}&${payload}`;
		return this.apiService.get(URL);
	}
	// TODO:
	associateTrainerToSelectedScheme(
		trainerId,
		tpUserName?: string,
		schemeId?: string,
		info: any = {},
		otp?: any
	) {
		const user = this.currentUserService.getCurrentUserLocal().value;
		tpUserName = tpUserName || user.userName;
		const role = user.role;
		const params = {
			tpUserName,
			schemeId
		};
		Object.assign(params, info);
		if (otp) {
			Object.assign(params, otp);
		}
		const query = Helpers.serialize(params);
		const URL = `${
			environment.trainingPartnerServiceURL
			}/api/trainingpartnerservice/v1/trainingpartner/trainers/${trainerId}/Associated?${query}`;
		// }/api/trainingpartnerservice/v1/trainingpartner/trainers/${trainerId}/Associate`;
		return this.apiService.put(URL, params);
	}

	getAllAssessmentRequests(pageNo, itemPerPage, queryParams?) {
		const URL =
			`${
			environment.userServiceUrl
			}/api/user/v1/trainingcentre/workflow?pageNo=` +
			pageNo +
			'&limit=' +
			itemPerPage;
		return this.apiService.get(URL);
	}

	getAssessmentById(tcId) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainingcentre/${tcId}`;
		return this.apiService.get(URL);
	}

	saveQCReview(tcId: string, data: any) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainingcentre/caaf/${tcId}/reviews`;
		return this.apiService.put(URL, data, true);
	}
	qcSubmitrefactor(tcId: string, data: any) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainingcentre/caaf/${tcId}/qcreviews`;
		return this.apiService.put(URL, data, true);
	}
	saveApealSubAdmin(data: any) {
		const URL = `${
			environment.smartServiceURL
			}/api/smart/v1/appeal/change/qc/decision`;
		return this.apiService.post(URL, data);
	}
	addCandidate(data: any) {
		const URL = `${environment.userServiceUrl}/api/user/v1/candidates/reg`;
		return this.apiService.post(URL, data);
	}

	getCompleteBatches(pageNo, itemsPerPage, type) {
		const URL =
			`${
			environment.userServiceUrl
			}/api/user/v1/trainer/jobroles/certification?pageNo=` +
			pageNo +
			'&itemsPerPage=' +
			itemsPerPage +
			'&type=' +
			type;
		return this.apiService.get(URL);
	}

	addJobRolesToTrainer(userName: string, jobRoles: any[]) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/update/jobroles?userName=${userName}`;
		return this.apiService.patch(URL, { jobRoles: jobRoles });
	}

	getTrainersOfLocation(role: string, userName: string, pageNo: number, limit: number, pagination?: string, ) {
		const URL = `${environment.userServiceUrl}/api/user/v1/camps/list/jobroles?role=${role}&userName=${userName}
		&pageNo=${pageNo}&limit=${limit}&pagination=${pagination}`;
		return this.apiService.get(URL);
	}

	getRPLTrainers(projectId, tcId: string, trainerId = '', limit?: number, pageNum?: number) {
		let query: string;
		if (limit && pageNum) {
			query = `&limit=${limit}&pageNo=${pageNum}`;
		}
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/get/trainers/associated/trainers/rpl?${query}&tcUserName=
			${tcId}&projectId=${projectId}&userName=${trainerId}&fields=userName,phone,email,
			name,associations,jobRoles,address`;
		return this.apiService.get(URL);
	}

	getTrainersOfTc(projectId, tcId: string, trainerId = '', limit?: number, pageNum?: number) {
		// const URL = `${environment.userServiceUrl}/api/user/v1/get/trainers/associatedtcid/
		// username?tcUserName=${tcId},userName=${trainerId ? trainerId : ''}&fields=associations,jobRoles,userName,name,email,phone`;
		// return this.apiService.get(URL);
		let query: string;
		if (limit && pageNum) {
			query = `&limit=${limit}&pageNo=${pageNum}`;
		}
		const URL = `${
			environment.userServiceUrl
			// tslint:disable-next-line:max-line-length
			}/api/user/v1/get/trainers/associatedtcid/username?${query}&tcUserName=${tcId}&projectId=${projectId}&userName=${trainerId}&fields=userName,phone,email,name,associations,jobRoles,address`;
		return this.apiService.get(URL);
	}

	getTrainersOfAATc(projectId, tcId: string, tpId: string, limit?: number, pageNum?: number) {
		let query: string;
		if (limit && pageNum) {
			query = `&limit=${limit}&pageNo=${pageNum}`;
		}
		const URL = `${
			environment.userServiceUrl
			// tslint:disable-next-line:max-line-length
			}/api/user/v1/get/trainers/by/jobRoleTcid?${query}&tcUserName=${tcId}&projectId=${projectId}&tpId=${tpId}`;
		return this.apiService.get(URL);
	}

	deLinkRaiseRequest(data) {
		const url = `${
			environment.trainingPartnerServiceURL
			// tslint:disable-next-line:max-line-length
			}/api/trainingpartnerservice/v1/trainingpartner/${data.tpUserName}/trainers/delinktrainer/${data.trainerName}?tcId=${data.associations.tcUserName ? data.associations.tcUserName : ''}`;
		return this.apiService.put(url, data.payload);
	}

	deLinkApproveRejectRequest(data) {
		const url = `${
			environment.trainingPartnerServiceURL
			// tslint:disable-next-line:max-line-length
			}/api/trainingpartnerservice/v1/trainingpartner/trainers/${data.tpUserName}/delink/${data.trainerName}?status=${data.actionStatus}&tcId=${data.associations.tcUserName ? data.associations.tcUserName : ''}`;
		return this.apiService.put(url);
	}

	getTrainerJobRolesAndInfo(userName: string) {
		const url = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/username/jobrole/${userName}`;
		return this.apiService.get(url);
	}

	saveCmViewDetails(data: any) {
		const url = `${
			environment.userServiceUrl
			}/api/user/v1/trainingcentre/cm/ia/action`;
		return this.apiService.post(url, data);
	}

	getPublicTrainerList(pageNo: number, perPageNo: number, data?: any) {
		console.log(data);
		const objbatch = {
			originationCategory: data.originationCategory ? data.originationCategory : '',
			typeOfCertification: data.typeOfCertification ? data.typeOfCertification : '',
			country: data.country && data.country.countryId !== 'IN' ? data.country.countryId : '',
			state: data.state ? data.state : '',
			sector: data.sector ? data.sector : '',
			jobRole: data.jobRole ? data.jobRole : '',
			status: data.status ? data.status : '',
			trId: data.trainerId ? data.trainerId : '',
			trName: data.trainerName ? data.trainerName : '',
			totStatus: data.totStatus ? data.totStatus : '',
			citsTrainer: data.citsTrainer ? data.citsTrainer : '',
			pageNo: pageNo,
			limit: perPageNo
		};

		const url = `${
			environment.userServiceUrl
			}/api/user/v1/trainers/public/jobroles/all?state=${
			objbatch.state
			}&sector=${objbatch.sector}&jobRole=${objbatch.jobRole}&trId=${objbatch.trId}
			&trName=${objbatch.trName}&status=${objbatch.totStatus}&limit=${perPageNo}
			&pageNo=${pageNo}&originationCategory=${objbatch.originationCategory}&typeOfCertification=${objbatch.typeOfCertification}
			&countryCode=${objbatch.country}&citsTrainer=${objbatch.citsTrainer}`;
		// console.log(url, data);

		return this.apiService.get(url);
	}

	generateOtpToAddTrainer(phoneNumber: number, email: string, trainingType?: string) {
		let url = `${environment.userServiceUrl}/api/user/reg/v1/generateOTP/Trainer?scenario=addtrainer`;
		if (trainingType) {
			url = url.concat(`&trainingType=${trainingType}`);
		}
		return this.apiService.post(url, { phoneNumber: phoneNumber, email: email });
	}

	/**
	 * Pmkvy
	 */
	createTrainerOnOtpVerification(data, phoneOtp, emailOtp) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainer/${phoneOtp}/${emailOtp}?source=other&step=addtrainer`;
		return this.apiService.post(url, data);
	}

	linkJobRoleToTrainerAndActor(data: any, schemeId?) {
		/* SchemeId is project Id */
		let url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/update/byloginrole`;
		if (schemeId) {
			url = url.concat(`?schemeId=${schemeId}`);
		}
		return this.apiService.patch(url, data);
	}
	getTrainerInfoErrorhandling(userName) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/username/errorhandle/tr?userName=${userName}`;
		// api/user/v1/trainer/username/errorhandle/tr?userName=TC123/123
		return this.apiService.get(URL);
	}
	getCIGradingMatrix(tcDetails) {
		const url = `${environment.userServiceUrl}/api/user/v1/centreinspector/gradingmatrix`;
		return this.apiService.put(url, tcDetails)
	}
	getBatchDetailsOfTrainer(trainerId) {
		const URL = `${
			environment.userServiceUrl
			}/api/batch/v1/trainer/associate/with/active/batches?trainerId=${trainerId}`;
		// api/user/v1/trainer/username/errorhandle/tr?userName=TC123/123
		return this.apiService.get(URL);
	}
	getTrainerCountInfo(trainerId) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainerpresentmorethanone?trainerID=${trainerId}`;
		// api/user/v1/trainer/username/errorhandle/tr?userName=TC123/123
		return this.apiService.get(URL);
	}

	getTrainerValidcertificate(trainerId, qpCode?, version?) {
		const data = {
			qpCode: encodeURIComponent(qpCode),
			userName: trainerId,
			version: version
		}
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/validcertificate/list`;
		return this.apiService.get(URL, data);
	}
	downloadUpdatedInspectionReport() {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/trainer/validcertificate/list`;
		return this.apiService.get(URL);
	}
	gradingAfterUpdateInspection(userName) {
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/holdingAgency/caluclategrading/${userName}`;
		return this.apiService.get(URL);
	}
	viewUpdatedInspectionReport(data) {
		const URL = `${
			environment.smartServiceURL
			}/api/smart/v1/appeal/viewtempspecialcaseReport`;
		return this.apiService.post(URL, data);
	}

}
